export default __webpack_public_path__ + "static/media/logo.d306e789.png";